import React from 'react';
import { DirectionToggle } from '../shared/DirectionToggle';

interface HigherLowerParamsProps {
  direction: 'higher' | 'lower';
  barrier: string;
  duration: string;
  onDirectionChange: (direction: 'higher' | 'lower') => void;
  onBarrierChange: (barrier: string) => void;
  onDurationChange: (duration: string) => void;
}

const HigherLowerParams: React.FC<HigherLowerParamsProps> = ({
  direction,
  barrier,
  duration,
  onDirectionChange,
  onBarrierChange,
  onDurationChange
}) => {
  const adjustBarrier = (increment: boolean) => {
    const currentValue = parseFloat(barrier);
    const adjustment = increment ? 0.00001 : -0.00001;
    const newValue = (currentValue + adjustment).toFixed(5);
    onBarrierChange(newValue);
  };

  return (
    <>
      <div className="parameter-group">
        <label>Direction</label>
        <DirectionToggle
          leftLabel="Higher"
          rightLabel="Lower"
          selectedDirection={direction}
          onDirectionChange={(dir) => onDirectionChange(dir as 'higher' | 'lower')}
        />
      </div>

      <div className="parameter-group">
        <label>Barrier</label>
        <div className="barrier-controls">
          <div className="barrier-input-group">
            <button 
              className="barrier-btn"
              onClick={() => adjustBarrier(false)}
            >
              -
            </button>
            <input 
              type="text" 
              className="input-field barrier-input" 
              value={barrier}
              readOnly
            />
            <button 
              className="barrier-btn"
              onClick={() => adjustBarrier(true)}
            >
              +
            </button>
          </div>
          <div className="barrier-info">
            <span className="barrier-distance">+5 pips from current</span>
          </div>
        </div>
      </div>

      <div className="parameter-group">
        <label>Duration</label>
        <select 
          className="input-field"
          value={duration}
          onChange={(e) => onDurationChange(e.target.value)}
        >
          <option value="15 minutes">15 minutes</option>
          <option value="30 minutes">30 minutes</option>
          <option value="1 hour">1 hour</option>
          <option value="4 hours">4 hours</option>
          <option value="1 day">1 day</option>
        </select>
      </div>
    </>
  );
};

export default HigherLowerParams;
export { HigherLowerParams };
